import React, { useRef, useState } from "react";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import { shortDate } from "../../helpers/dateHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import { ROW_COUNT } from "../../helpers/variableHelper";
import { AdminListaPagination } from "../../controls/AdminListaPagination";
import LIOService from "../../services/LIOService";
import IInspeccionObservacion, { ISearchHistoricoLIO } from "../../entities/IInspeccionObservacion";
import Loading from "../../cross/Loading";
import RenderTitle from "../../controls/RenderTitle";
import RenderValue from "../../controls/RenderValue";
interface IHistoricoLIOProps {
  items?: Array<IInspeccionObservacion>;
  loading?: boolean;
}

export default function HistoricoLIO({ items, loading = true }: IHistoricoLIOProps) {
  const [token, setToken] = useState("");
  const totalPageList = useRef<number>(0);
  const [listLIO, setListLIO] = useState<Array<IInspeccionObservacion>>(items || []);
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(loading);
  const [filtrosColumnas, setFiltrosColumnas] = useState<ISearchHistoricoLIO>({
    ORDENADOPOR: "ID",
    ORIENTACION: "DESC",
    PAGINA: 1,
    PAGINADO: ROW_COUNT,
  });
  const [isDownloading, setIsDownloading] = useState(false);
  console.log(currentUser);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentOpciones = (info: any) => {
    return (
      <div>
        <i
          data-testid="test1"
          className="bi bi-search iconSearch"
          title="Ver Inspeccion Observacion"
          onClick={() => {
            window.location.href = `/agregarLIO?id=${info.row.original.ID}`;
          }}></i>
      </div>
    );
  };
  usePromiseEffect(async () => {
    let token = await cognitoUserToken();
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    await reload();
  }, []);

  const reload = async (filtros?: ISearchHistoricoLIO) => {
    let f = filtros || filtrosColumnas;
    let token = await cognitoUserToken();
    let lios = await LIOService.getListadoHistorico(token, f);

    setListLIO(!lios ? items : lios.data);
    totalPageList.current = lios.pages;
    setIsLoading(false);
    setFiltrosColumnas(f);
  };

  const handleExportExcel = async () => {
    if (filtrosColumnas) {
      await LIOService.getExcelHistorico(token, filtrosColumnas);
    }
    setIsDownloading(false);
  };

  const columnHelperLioHistorico = createColumnHelper<ISearchHistoricoLIO>();
  let columnsDefLio = [
    columnHelperLioHistorico.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentOpciones(info),
      header: () => component("Opciones"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Vicepresidencia"),
      tipo: ITipo_Campo.text,
      sortId: `VPP."TITULO"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.GERENCIA_SUBGERENCIA, {
      id: "GERENCIA_SUBGERENCIA",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Gerencia Subgerencia"),
      tipo: ITipo_Campo.text,
      sortId: `GSG."TITULO"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.UNIDAD_PROYECTO, {
      id: "UNIDAD_PROYECTO",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Unidad Proyecto"),
      tipo: ITipo_Campo.text,
      sortId: `UP."TITULO"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.CONTRATISTA_SUBCONTRATISTA, {
      id: "CONTRATISTA_SUBCONTRATISTA",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Contratista Subcontratista"),
      tipo: ITipo_Campo.text,
      sortId: `CSC."TITULO"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.FECHA_DETECCION, {
      id: "FECHA_DETECCION",
      cell: (info: CellContext<ISearchHistoricoLIO, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Detección"),
      tipo: ITipo_Campo.date,
      sortId: `LIO."FECHA_DETECCION"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.OBSERVACIONES, {
      id: "OBSERVACIONES",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Observación"),
      tipo: ITipo_Campo.text,
      sortId: `LIO."OBSERVACIONES"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.CORRELATIVO, {
      id: "CORRELATIVO",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Correlativo"),
      tipo: ITipo_Campo.text,
      sortId: `LIO."CORRELATIVO"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.INSTALACION_INTERVENIR, {
      id: "INSTALACION_INTERVENIR",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Instalación a Intervenir"),
      tipo: ITipo_Campo.text,
      sortId: `LIO."INSTALACION_INTERVENIR"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.INSPECTOR, {
      id: "INSPECTOR",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Inspector Transelec"),
      tipo: ITipo_Campo.text,
      sortId: `LIO."INSPECTOR_FAENA"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.TIPO_FAENA, {
      id: "TIPO_FAENA",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Tipo Faena"),
      tipo: ITipo_Campo.text,
      sortId: `TF."TITULO"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.FAENA, {
      id: "FAENA",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Faena"),
      tipo: ITipo_Campo.text,
      sortId: `LIO."HORARIO"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.ATN, {
      id: "ATN",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("AT N°"),
      tipo: ITipo_Campo.text,
      sortId: `LIO."ATN"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.ENCARGADO_ZONAL, {
      id: "ENCARGADO_ZONAL",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Encargado Zonal"),
      tipo: ITipo_Campo.text,
      sortId: `LIO."USUARIO_ENCARGADO_ZO_DISPLAY"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.TIPO_LISTA, {
      id: "TIPO_LISTA",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Tipo Lista"),
      tipo: ITipo_Campo.text,
      sortId: `TL."TITULO"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.ESTADO, {
      id: "ESTADO",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Estado"),
      tipo: ITipo_Campo.text,
      sortId: `EIO."TITULO"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.FECHA_CIERRE, {
      id: "FECHA_CIERRE",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Cierre"),
      tipo: ITipo_Campo.date,
      sortId: `LIO."FECHA_CIERRE"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.CERRADO_POR, {
      id: "CERRADO_POR",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Cerrado Por"),
      tipo: ITipo_Campo.text,
      sortId: `LIO."CERRADO_POR_DISPLAY"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.FECHA_CREACION, {
      id: "FECHA_CREACION",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Creado"),
      tipo: ITipo_Campo.date,
      sortId: `LIO."FECHA_CREACION"`,
    } as any),
    columnHelperLioHistorico.accessor((row) => row.CREADO_POR, {
      id: "CREADO_POR",
      cell: (info: CellContext<ISearchHistoricoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Creado Por"),
      tipo: ITipo_Campo.text,
      sortId: `LIO."AUTOR_DISPLAY"`,
    } as any),
  ] as any;
  return (
    <div className="row">
      <div className="col-12">
        <div className="rounded bg-white p-2">
          <div className="container-fluid mb-4">
            <div className="" id="collapseGeneradas">
              <div className="card card-body border-0 p-0 mt-2">
                <div className="row">
                  <div className="col-12">
                    <div className="container-fluid mb-4">
                      <h1 className="titPrincipal colorTit mt-2"></h1>
                      <div className="row">
                        <div className="col-12 p-0">
                          <h1 className="titPrincipal colorTit mt-2">Histórico Inspección y Observación</h1>
                          <div>
                            {isDownloading && <Loading key="loadingDownload" cssContainer="loadingFlotante" />}
                            {isLoading ? (
                              <Loading></Loading>
                            ) : (
                              <AdminListaPagination
                                defaultSortBy="ID"
                                sortDirection="DESC"
                                totalPages={totalPageList}
                                resultPerPage={ROW_COUNT}
                                callback={(pagination: any) => {
                                  reload(pagination);
                                }}
                                data={listLIO || []}
                                reload={() => {
                                  reload();
                                }}
                                columnsDef={columnsDefLio}
                                hideAdd={true}
                                hideExport={true}
                              />
                            )}
                          </div>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-success me-2"
                            onClick={() => {
                              setIsDownloading(true);
                              handleExportExcel();
                            }}>
                            <i className="bi bi-file-earmark-excel"></i> Exportar Excel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
